import axios from 'axios';
import HOST from '@/store/host';
import { showNotification } from '@/helpers/helpers';

const actions = {
  submitContactUsForm(ctx, { body, notificationParams }) {
    return axios
      .post(`${HOST}/contact-us/`, body)
      .then(() => {
        showNotification(notificationParams);
      })
      .catch((error) => {
        showNotification({
          ctx: notificationParams.ctx,
          variant: 'danger',
          title: 'Error',
          message: error?.response?.data?.detail || 'An error occurred',
        });
        return Promise.reject();
      });
  },
};

export default {
  actions,
};
